var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 4.25A.75.75 0 0 0 10 3.5a.75.75 0 0 0-.75.75v5h-5a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h5v5c0 .416.334.75.75.75s.75-.334.75-.75v-5h5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75h-5z"
  })));
};
export default SvgAdd;